// src/pages/LandingPage.tsx
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
  Checkbox,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;
const supabase = createClient(supabaseUrl, supabaseAnonKey);

const LandingPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    acceptPolicy: false,
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!formData.acceptPolicy) {
      toast({
        title: "Debes aceptar la política de privacidad.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    setLoading(true);
    const { error } = await supabase.from("promo_access").insert([
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        accepted: true,
      },
    ]);
    setLoading(false);
    if (error) {
      toast({
        title: "Error al enviar los datos.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } else {
      toast({
        title: "¡Datos enviados con éxito!",
        description: "Gracias por registrarte. Tu regalo está listo para descargar.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      setFormData({
        name: "",
        email: "",
        phone: "",
        acceptPolicy: false,
      });
      setTimeout(() => {
        window.location.href = "/gift";
      }, 1500);
    }
  };

  return (
    <Box bg="#fdfcf9" minH="100vh" py={10}>
      <Container maxW="md">
        <Box
          bg="white"
          borderRadius="md"
          boxShadow="md"
          p={8}
          border="1px solid #e2e8f0"
        >
          <VStack spacing={6} align="stretch">
            <Heading size="lg" color="#225059" textAlign="center">
              Accede a tu regalo exclusivo 🎁
            </Heading>
            <Text textAlign="center" color="gray.600">
              Queremos agradecerte por elegir un pedacito de magia para tu hogar. Llena este pequeño formulario y desbloquea un regalo especial, creado con cariño por nuestro estudio para ti.
            </Text>
            <form onSubmit={handleSubmit}>
              <VStack spacing={4} align="stretch">
                <FormControl isRequired>
                  <FormLabel>Nombre completo</FormLabel>
                  <Input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Correo electrónico</FormLabel>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Teléfono</FormLabel>
                  <Input
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </FormControl>
                <Checkbox
                  name="acceptPolicy"
                  isChecked={formData.acceptPolicy}
                  onChange={handleChange}
                  colorScheme="teal"
                >
                  Acepto la{" "}
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#225059", textDecoration: "underline" }}
                  >
                    política de privacidad
                  </a>
                  .
                </Checkbox>
                <Button
                  type="submit"
                  isLoading={loading}
                  colorScheme="teal"
                  width="full"
                >
                  Descargar mi regalo ✨
                </Button>
              </VStack>
            </form>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default LandingPage;
